/**
 * Settings → メールテンプレート作成: 招待 / 再提出 / 完了
 */
import React, { useState } from 'react';
import MailTemplateTabPanel from './MailTemplateTabPanel';
import { getPlaceholderWarnings } from '../../documentManagement/checkSubmissions/resubmissionManagement/emailTemplates';
import './mailTemplates.css';

export type MailTemplatesTab = 'invitation' | 'resubmission' | 'completion' | 'submission';

const INV_SUBJECT_HINT = '以下のプレースホルダーは変更・削除しないでください: {受信者名}, {締切日}';
const INV_BODY_HINT =
  '以下のプレースホルダーは変更・削除しないでください: {受信者メールアドレス}, {パスワード}, {締切日}';
const SUBMISSION_BODY_HINT =
  '以下のプレースホルダーは変更・削除しないでください: {受信者名}, {WebサイトURL}, {原本送付案内}';

const MailTemplatesSettings: React.FC = () => {
  const [activeTab, setActiveTab] = useState<MailTemplatesTab>('invitation');

  return (
    <div className="mail-templates-settings">
      <div className="mail-templates-settings__tabs" role="tablist" aria-label="メールテンプレート種別">
        <button
          type="button"
          role="tab"
          id="mail-templates-tab-invitation"
          aria-selected={activeTab === 'invitation'}
          aria-controls="mail-templates-panel-invitation"
          className={`mail-templates-settings__tab ${activeTab === 'invitation' ? 'mail-templates-settings__tab--active' : ''}`}
          onClick={() => setActiveTab('invitation')}
        >
          招待
        </button>
        <button
          type="button"
          role="tab"
          id="mail-templates-tab-resubmission"
          aria-selected={activeTab === 'resubmission'}
          aria-controls="mail-templates-panel-resubmission"
          className={`mail-templates-settings__tab ${activeTab === 'resubmission' ? 'mail-templates-settings__tab--active' : ''}`}
          onClick={() => setActiveTab('resubmission')}
        >
          再提出
        </button>
        <button
          type="button"
          role="tab"
          id="mail-templates-tab-submission"
          aria-selected={activeTab === 'submission'}
          aria-controls="mail-templates-panel-submission"
          className={`mail-templates-settings__tab ${activeTab === 'submission' ? 'mail-templates-settings__tab--active' : ''}`}
          onClick={() => setActiveTab('submission')}
        >
          提出完了
        </button>
        <button
          type="button"
          role="tab"
          id="mail-templates-tab-completion"
          aria-selected={activeTab === 'completion'}
          aria-controls="mail-templates-panel-completion"
          className={`mail-templates-settings__tab ${activeTab === 'completion' ? 'mail-templates-settings__tab--active' : ''}`}
          onClick={() => setActiveTab('completion')}
        >
          承認完了
        </button>
      </div>

      {activeTab === 'invitation' && (
        <div
          id="mail-templates-panel-invitation"
          role="tabpanel"
          aria-labelledby="mail-templates-tab-invitation"
          className="mail-templates-settings__panel"
        >
          <MailTemplateTabPanel
            templateKey="INVITATION"
            subjectPlaceholderHint={INV_SUBJECT_HINT}
            bodyPlaceholderHint={INV_BODY_HINT}
          />
        </div>
      )}

      {activeTab === 'resubmission' && (
        <div
          id="mail-templates-panel-resubmission"
          role="tabpanel"
          aria-labelledby="mail-templates-tab-resubmission"
          className="mail-templates-settings__panel"
        >
          <MailTemplateTabPanel
            templateKey="RESUBMISSION_REQUEST"
            subjectPlaceholderHint={getPlaceholderWarnings('rejected', 'subject')}
            bodyPlaceholderHint={getPlaceholderWarnings('rejected', 'body')}
          />
        </div>
      )}

      {activeTab === 'submission' && (
        <div
          id="mail-templates-panel-submission"
          role="tabpanel"
          aria-labelledby="mail-templates-tab-submission"
          className="mail-templates-settings__panel"
        >
          <MailTemplateTabPanel
            templateKey="SUBMISSION_COMPLETE"
            subjectPlaceholderHint="以下のプレースホルダーは変更・削除しないでください: {受信者名}"
            bodyPlaceholderHint={SUBMISSION_BODY_HINT}
          />
        </div>
      )}

      {activeTab === 'completion' && (
        <div
          id="mail-templates-panel-completion"
          role="tabpanel"
          aria-labelledby="mail-templates-tab-completion"
          className="mail-templates-settings__panel"
        >
          <MailTemplateTabPanel
            templateKey="APPROVAL_NOTICE"
            subjectPlaceholderHint={getPlaceholderWarnings('approved', 'subject')}
            bodyPlaceholderHint={getPlaceholderWarnings('approved', 'body')}
          />
        </div>
      )}
    </div>
  );
};

export default MailTemplatesSettings;
